import { reactIcons } from "../../utils/icons";

const DesktopCountryForm = ({
  errorMsg,
  handleCountryChange,
  selectedCountry,
  Country
}) => {
  return (
    <>
      <div className="input_field mb-3 lg:mb-0">
        <div className="relative">
          <label className="mb-2 block text-white">
            Country of Incorporation
          </label>
          <select
            className="bg-white text-12 lg:text-14"
            onChange={handleCountryChange}
            value={selectedCountry}
          >
            {Country.getAllCountries().map((country) => {
              return (
                <option
                  className="bg-white text-black"
                  key={country.isoCode}
                  value={country.isoCode}
                >
                  {country.name}
                </option>
              );
            })}
          </select>
          <span className="absolute top-[43px] lg:top-[50px] right-[10px]">
            {reactIcons.arrowDown}
          </span>
        </div>
        {errorMsg.country && (
          <div className="form-eror">{errorMsg.country}</div>
        )}
      </div>
    </>
  );
};
export default DesktopCountryForm;
